// extracted by mini-css-extract-plugin
export var contentContainer = "DisclaimerModule-module--contentContainer--HkIV9";
export var copy = "DisclaimerModule-module--copy--gzSpG";